import { apiRequest } from './authService';

/**
 * Kassa Gold buy-log service. Exact duplicate of goldPurchaseService but on the
 * kassa-gold/* endpoints (separate tables). Cash paid on each line is deducted
 * from the Kassa saldo.
 */

export async function getDay(date) {
  try {
    const response = await apiRequest('kassa-gold/day', {
      method: 'POST',
      body: JSON.stringify({ date })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to load day' };
  } catch (e) {
    console.error('kassaGold getDay error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function getDayVersion(date) {
  try {
    const response = await apiRequest('kassa-gold/day-version', {
      method: 'POST',
      body: JSON.stringify({ date })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data };
    }
    return { success: false };
  } catch (e) {
    return { success: false };
  }
}

export async function findByNote(note) {
  try {
    const response = await apiRequest('kassa-gold/find-note', {
      method: 'POST',
      body: JSON.stringify({ note })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Not found' };
  } catch (e) {
    console.error('kassaGold findByNote error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function getSettings() {
  try {
    const response = await apiRequest('kassa-gold/settings', { method: 'POST' });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to load settings' };
  } catch (e) {
    console.error('kassaGold getSettings error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function setDefaultRate(rate) {
  try {
    const response = await apiRequest('kassa-gold/set-rate', {
      method: 'POST',
      body: JSON.stringify({ rate })
    });
    if (response.success) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to set rate' };
  } catch (e) {
    console.error('kassaGold setDefaultRate error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function addRow(date) {
  try {
    const response = await apiRequest('kassa-gold/add-row', {
      method: 'POST',
      body: JSON.stringify({ date })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to add row' };
  } catch (e) {
    console.error('kassaGold addRow error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function updateRow(id, fields) {
  try {
    const response = await apiRequest('kassa-gold/update-row', {
      method: 'POST',
      body: JSON.stringify({ id, ...fields })
    });
    if (response.success && response.data) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to update row' };
  } catch (e) {
    console.error('kassaGold updateRow error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function deleteRow(id) {
  try {
    const response = await apiRequest('kassa-gold/delete-row', {
      method: 'POST',
      body: JSON.stringify({ id })
    });
    if (response.success) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to delete row' };
  } catch (e) {
    console.error('kassaGold deleteRow error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function addAdjustment(date, type, amount) {
  try {
    const response = await apiRequest('kassa-gold/add-adjustment', {
      method: 'POST',
      body: JSON.stringify({ date, type, amount })
    });
    if (response.success) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to add adjustment' };
  } catch (e) {
    console.error('kassaGold addAdjustment error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

export async function undoAdjustment(date) {
  try {
    const response = await apiRequest('kassa-gold/undo-adjustment', {
      method: 'POST',
      body: JSON.stringify({ date })
    });
    if (response.success) {
      return { success: true, data: response.data, message: response.response };
    }
    return { success: false, message: response.response || 'Failed to undo adjustment' };
  } catch (e) {
    console.error('kassaGold undoAdjustment error:', e);
    return { success: false, message: 'Network error. Please try again.' };
  }
}
